<template>
	<div class="download">
		<div class="title-box">
			<img src="@/assets/images/title_down.png"/>
		</div>
		<div class="main">
			<div class="in">
				<div class="left">
					<img class="title" src="@/assets/images/title_down_1.png"/>
					<div class="btns">
						<div class="btn ios" @click="download('ios')">
							<img src="@/assets/images/apple_w.png"/>
							<div class="text">
								<span class="t1">Download on the</span>
								<span class="t2">App Store</span>
							</div>
						</div>
						<div class="btn android" @click="download('android')">
							<img src="@/assets/images/android_g.png"/>
							<div class="text">
								<span class="t1">Download it from</span>
								<span class="t2">Android Market</span>
							</div>
						</div>
					</div>
				</div>
				<div class="right">
					<img src="@/assets/images/phone_home_v2.png"/>
				</div>
			</div>
		</div>
		<div class="btm-bg"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		mounted() {},
		methods: {
			download(type){
				if(type === 'android'){
					window.open('https://package.luyouxuan.com/package/LuYouXuan.apk')
				}else if(type === 'ios'){
					window.open('https://apps.apple.com/cn/app/id6636531470')
				}
			}
		},
	}
</script>

<style scoped lang="less">
	.download{
		padding-top: 130px;
		background: #FBFBFB;
	}
	.title-box{
		margin-bottom: 20px;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: 84px;
		}
	}
	.btm-bg{
		height: 360px;
		background:#F3405B url("../../assets/images/btm_down.png") no-repeat left center;
		background-size: auto 360px;
		position: relative;
		z-index: 1;
		margin-top: -300px;
	}
	.main{
		position: relative;
		z-index: 2;
		.in{
			width: 1100px;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
		}
		.left{
			padding-top: 70px;
			.btns{
				display: flex;
				.btn{
					height: 50px;
					border-radius: 4px;
					display: flex;
					align-items: center;
					margin-right: 16px;
					padding: 0 10px;
					box-sizing: border-box;
					cursor: pointer;
					transition: all 0.3s;
					&:hover{
						opacity: 0.8;
					}
					img{
						width: 40px;
						height: auto;
						margin-right: 10px;
					}
					.text{
						display: flex;
						flex-direction: column;
						.t1{
							font-size: 12px;
							line-height: 1;
						}
						.t2{
							font-size: 18px;
							line-height: 1;
						}
					}
				}
				.ios{
					background: #000000;
					.text{
						color:#fff;
					}
				}
				.android{
					border: #C0AEAE 1px solid;
					.text{
						color:#000;
					}
				}
			}
			.title{
				width: auto;
				height: 120px;
				margin-bottom: 80px;
			}
		}
		.right{
			img{
				width: 700px;
				height: auto;
				margin-right: -80px;
				animation: floatAnimation 3s infinite;
			}
		}
	}
	@keyframes floatAnimation {
	  0% {
	    transform: translateY(0);
	  }
	  50% {
	    transform: translateY(30px);
	  }
	  100% {
	    transform: translateY(0);
	  }
	}
</style>